import { SectionTitle } from "@/components/Kpi";
import { useAuth } from "@/context/AuthContext";
import { BudgetAgenzieCorto, CollegamentoCrm, ContoCartaCorto, GiorniCorto, OperatoriCorto, RedditivitaCorto, RischioCorto,
  VisualizzazioneCorto } from "@/components/CollegamentoCrm";
import { MonitoraggioQuarterConfig } from "@/components/MonitoraggioQuarterConfig";

export default function ConfigurazioniCorto() {
  const { puo } = useAuth();
  return (
    <div className="space-y-6" data-testid="configurazioni-corto-page">
      <SectionTitle sub="Collegamento CRM, giorni lavorativi, redditività, DB Conto Carta, rischio, operatori, budget agenzie, visualizzazione e monitoraggio quarter">
        Configurazioni · canale corto
      </SectionTitle>
      <CollegamentoCrm />
      <GiorniCorto />
      <RedditivitaCorto />
      <ContoCartaCorto />
      <RischioCorto />
      <VisualizzazioneCorto />
      <OperatoriCorto />
      <BudgetAgenzieCorto />
      {puo("monitoraggio_quarter") && <MonitoraggioQuarterConfig />}
    </div>
  );
}
